import { render, staticRenderFns } from "./StatisticsTab.vue?vue&type=template&id=242ff84e&scoped=true&"
import script from "./StatisticsTab.vue?vue&type=script&lang=js&"
export * from "./StatisticsTab.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsTab.vue?vue&type=style&index=0&id=242ff84e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242ff84e",
  null
  
)

export default component.exports